import { IEntity } from './entity';
import { Employee } from './employee';
import { MaterialProcurementStatus } from './material-procurement-status';

export class EntityCollection{
  constructor(){
    this.jobTypes = [];
    this.projectStatuses = [];
    this.areas = [];
    this.clientEngineers = [];
    this.installationProgresses = [];
    this.responsibleEngineers = [];
    this.materialProcurementStatuses = [];
  }

  jobTypes: IEntity[];
  projectStatuses: IEntity[];
  areas: IEntity[];
  clientEngineers: IEntity[];
  installationProgresses: IEntity[];
  responsibleEngineers: Employee[];
  materialProcurementStatuses: MaterialProcurementStatus[];
}